import ApplicationDecline from 'features/payOverTime/screens/application/ApplicationDecline/ApplicationDecline';
import React from 'react';

export default function Page() {
  return <ApplicationDecline />;
}
